<template>
<!--  <div >
    <div class="registered">
      <div class="registered_img"><img src="../../static/img/ren1.png" alt=""></div>
      <div class="registered_ul">
      <ul>
        <li>
          <strong>手机号</strong>
          <input type="number" placeholder="请输入手机号码"   oninput="if(value.length>11)value=value.slice(0,11)" v-model.trim="phone" value="" />
        </li>
        <li class="validation clearfix">
          <div class="lf">
            <strong>验证码</strong>
            <input type="number" placeholder="短信验证码"  v-model.trim="verify">
          </div>
          <span v-if="sendMsgDisabled" class="rg">{{time+'秒后获取'}}</span>
          <span v-if="!sendMsgDisabled"  @click="send" class="rg">获取验证码</span>
        </li>
        <li>
          <strong>密码</strong>
          <input :type="password" placeholder="请设置密码(6-20位数字和字母组合)" ref ="password" v-model.trim="pas" oninput="if(value.length>20)value=value.slice(0,20)">
          <div class="ShutDown rg">
            <em class="iconfont icon-yanjing"  @click="eye"  v-if="Shut"></em>
            <em class="iconfont icon-in_biyan" @click="eye" v-if="!Shut"></em>
          </div>
        </li>
        <li>
          <strong>邮箱</strong>
          <input type="text" placeholder="请输入邮箱" v-model.trim="email">
        </li>
      &lt;!&ndash;  <li class="btn" @click="prosperity">下一步</li>
        <li class="agreement clearfix">
          点击"下一步"，即表示您同意遵守 <span @click="useragreement"> 【用户协议】</span>
        </li>&ndash;&gt;
      </ul>
        <div class="btn" @click="prosperity">下一步</div>
        <div class="agreement clearfix"> 点击"下一步"，即表示您同意遵守 <span @click="useragreement"> 【用户协议】</span></div>
      </div>
    </div>
     <div class="autonym_shiming" v-show="shimingShow">
        <h2>实名认证</h2>
        <ul class="autonym">
          <li>
            <span>姓名</span>
            <input  class="realName" type="text" placeholder="请输入真实姓名" v-model.trim="realName">
          </li>
          <li>
            <span>证件号码</span>
            <input type="text" placeholder="请输入您的身份证号码" v-model.trim="identityCode" oninput="if(value.length>18)value=value.slice(0,18)">
          </li>
        </ul>
        <div class="btn btn_wc" @click="autonymYeal">完成</div>
    </div>

    <div class='mask' v-show="shimingShow"></div>
    &lt;!&ndash; 提示框&ndash;&gt;
    <prompt ref="errBox" :infor1="infor1"></prompt>
    &lt;!&ndash;loading提示&ndash;&gt;
    <loading ref="loading"></loading>
  </div>-->
</template>

<script>
  import prompt from '@/components/prompt'
  import {getUrlStr} from '../../static/js/Subparameter'
  import loading from '@/components/loading'

  export default {
    data(){
      return{
        Shut:false,//眼睛
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
        infor1:"",
        phone:"",
        verify:"",
        pas:"",
        email:"",
        invitedCode:"",
        password:"password",
        invitationcode:"",
        yanzhengma:"",
        realName:"",
        identityCode:"",
        shimingShow:false,
      }
    },
    components: {
      prompt,
      loading,
    },
    mounted () {
      this.receive();
      window.location.href = 'https://mvhtb.hcmdonline.com/publicweixinV2/#/pages/register/vxRegister?invitationcode='+this.invitationcode;

      // this.getStorage();
    },
    methods:{
      //接受参数
      receive(){
        this.invitationcode = getUrlStr('invitationcode');
      },
      //眼睛
      eye:function(){
        this.Shut = !this.Shut;
        if(this.Shut == false ){
          this.password = 'password'
        }else{
          this.password = 'text'
        }
      },
      //下一步
      prosperity:function(){

        const email = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        const myreg=/^((1[0-9]{1})+\d{9})$/
        const reg = /^(?![^a-zA-Z]+$)(?!\D+$)/;
        let register = {
          telephone:this.phone,
          code:this.verify,
          password:this.pas,
          email:this.email,
          invitedCode:this.invitationcode,
        }
        if(register.telephone == "" || !myreg.test(register.telephone)){
          this.$refs.errBox.errorShow();
          this.infor1='请输入正确的手机号！'
          return false;
        }else if(register.code == "" || register.code !== this.yanzhengma){
          this.$refs.errBox.errorShow();
          this.infor1='请输入正确验证码！'
          return false;
        }else if(register.password == "" || !reg.test(register.password) ||  register.password.length< 6 ||register.password.length >20 ){
          this.$refs.errBox.errorShow();
          this.infor1='6-20位数字和字母组合!'
          return false;
        }else if(register.email == "" || !email.test(register.email)){
          this.$refs.errBox.errorShow();
          this.infor1="请输入正确的邮箱!"
          return false;
        }
        this.shimingShow = true;
        var h=$(window).height();
        $("body,html").css({"overflow":"hidden","height":h+"px"});
      },
      //获取短信验证码
      send:function() {
        this.$refs.loading.loadShow();
        const backdata={
          tel:this.phone,
          type:"0",
        }
        const myreg=/^((1[0-9]{1})+\d{9})$/
        if(this.phone == undefined || this.phone == ""||!myreg.test(this.phone)){
          this.sendMsgDisabled = false;
          this.$refs.loading.loadclose();
          this.$refs.errBox.errorShow();
          this.infor1 = '请输正确入手机号！'
          return false;
        }
        this.$http.get('/common/sendSmsCode',{params:backdata}).then(res => {
          var message = res.data.message;
        if(res.data.code == "200"){
          this.$refs.loading.loadclose();
          this.sendMsgDisabled = true;
          this.yanzhengma = res.data.data.verifyCode
          this.htnpop();
        }
        if(res.data.code == "500"){
          this.$refs.loading.loadclose();
          this.$refs.errBox.errorShow();
          this.infor1 = message;
          this.sendMsgDisabled = false;
          return false;
        }
      })
      },
      /* 校验提示*/
      htnpop:function(){
        window.clearInterval(interval);
        let me = this;
        me.sendMsgDisabled = true;
        let interval = window.setInterval(function () {
          if ((me.time--) <= 0) {
            me.time = 60;
            me.sendMsgDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);

      },
      /*用户协议*/
      useragreement:function(){
        sessionStorage.setItem('phone', this.phone);
        sessionStorage.setItem('verify', this.verify);
        sessionStorage.setItem('pas', this.pas);
        sessionStorage.setItem('email', this.email);
        sessionStorage.setItem('invitationcode', this.invitationcode);
        this.$router.push({
          name:"useragreement"
        })
      },
      //获取数据
      getStorage:function(){
        var phone = sessionStorage.getItem('phone')
        var  verify = sessionStorage.getItem('verify')
        var pas = sessionStorage.getItem('pas')
        var email =sessionStorage.getItem('email')
        var invitationcode =sessionStorage.getItem('invitationcode')

        if(this.phone == ""||this.phone==null){
          if(phone == null){
            this.phone = ""
          }else{
            this.phone = phone;
          }
        }
        if(this.verify == ""||this.verify==null){
          if(verify == null){
            this.verify = ""
          }else{
            this.verify = verify;
          }

        }
        if(this.pas == ""||this.pas==null){
          if(pas == null){
            this.pas = "";
          }else{
            this.pas = pas;
          }

        }
        if(this.email == ""||this.email==null){
          if(email == null){
            this.email = "";
          }else{
            this.email = email;
          }
        }
        if(this.invitationcode == ""||this.invitationcode==null){
          if(invitationcode == null){
            this.invitationcode = "";
          }else{
            this.invitationcode = invitationcode;
          }

        }

      },

       //注册接口
      autonymYeal: function () {
        let registerAutonym = {
          realName: this.realName,
          identityCode: this.identityCode
        }
        const em = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (registerAutonym.realName == "") {
          this.$refs.errBox.errorShow();
          this.infor1 = '请输真实姓名！'
          return false;
        } else if (registerAutonym.identityCode == "" || !em.test(registerAutonym.identityCode)) {
          this.$refs.errBox.errorShow();
          this.infor1 = '请输正确的身份证号！'
          return false;
        }
        //注册接口
        this.$http({
          method:"post",
          url:'/login/register',
          headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'},
          dataType: 'JSONP',
          params:{
            telephone: this.phone,
            code: this.verify,
            password: this.pas,
            email: this.email,
            invitedCode: this.invitationcode,
            realName: this.realName,
            identityCode: this.identityCode,
          }
        }).then(res => {
          var message = res.data.message;
        if(res.data.code == "200"){
          this.toggleBody(0);
          this.$router.push({
            name:"registerSuccess",
          })
        }
        if(res.data.code == "500"){
          this.$refs.errBox.errorShow();
          this.infor1 = message;
          return false;
        }
      })

      },
      toggleBody:function(isPin){
        if(isPin){
          document.body.style.height = '100vh';
          document.body.style['overflow-y'] = 'hidden';
        }
        else{
          document.body.style.height = 'unset';
          document.body.style['overflow-y'] = 'auto';
        }
      },

    }
  }
</script>

<style scoped lang="less">
  .registered{
    position:relative;
  .registered_img img{
    width:100%;
  }
  .agreement{
    border-bottom:none;
    text-align:center;
    font-size:12px;
    color:#ffffff;
    margin-top:37/75rem;
  span{
    color:#f8e7c0;
  }
  }
  .registered_ul{
    width:700/75rem;
    position:absolute;
    top:620/75rem;
    left:50%;
    transform:translate(-50%);
    -ms-transform: translate( -50%);
    -moz-transform: translate( -50%);
    -webkit-transform: translate( -50%);
    -o-transform: translate( -50%);
    margin:auto;
    border-radius:4/75rem;
    padding-top:20/75rem;
  }
  li{
    background:#FFFFFF;
    height:90/75rem;
    line-height:90/75rem;
    font-size:28/74rem;
    color:#cccccc;
    position: relative;
    margin-bottom:37/75rem;
    border-radius:5px;
  strong{
    display:inline-block;
    width:68px;
    text-align:center;
    color:#646464;
  }
  &.validation{
  background:none;
  div{
    background:#FFFFFF;
    border-radius:5px;
  }
  input{
    width:280/75rem;
  }
  span{
    width:220/75rem;
    height:90/75rem;
    line-height:90/75rem;
    margin:auto;
    color:#ffffff;
    background: #fecb0b;
    font-size:30/75rem;
    border-radius: 6px;
    text-align:center;
  }
  }
  input{
    width:460/75rem;
    border:none 0;
    padding-left:5/75rem;
    font-size:28/75rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  input::-webkit-input-placeholder{
    font-size:28/75rem;
    color:#cccccc;
  }
  }
  .ShutDown{
    position:absolute;
    top:0;
    right:17px;
    font-size:40/75rem;
  }
  /*保存*/

  }
  .btn{
    width:100%;
    height:45px;
    line-height:45px;
    margin:auto;
    background:#fecb0b;
    color:#fff;
    font-size:20px;
    border-radius: 6px;
    text-align:center;
    /*box-shadow:4px 0px 16px rgba(153,153,153,0.63);*/
  }

  /*实名认证*/
  .autonym_shiming{
    width:85%;
    background:#ededed;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    -ms-transform:translate( -50%,-50%);
    -moz-transform:translate( -50%,-50%);
    -webkit-transform:translate( -50%,-50%);
    -o-transform:translate( -50%,-50%);
    padding:20px 10px;
    border-radius:10px;
    z-index:12;
  }
  .autonym_shiming h2{
    font-size:20px;
    text-align:center;
    font-weight:bold;
    color:#646464;
  }
  .htn{
    padding:16/75rem 30/75rem;
    font-size:24/75rem;
    color:#E6464A;
    line-height:45/75rem;
    background:rgba(255,238,233,1);
  }
  .autonym{
  /*  background:#fff;*/
  li{
    font-size:30/75rem;
    height:100/75rem;
    line-height:100/75rem;
    padding:0 30/75rem;
    background:#ffffff;
    margin-top:20px;
  &:last-child{
     border-bottom:none;
   }
  .realName{
    margin-left:105/75rem;
  }
  input{
    margin-left:50/75rem;
    height:70/75rem;
    border:none;
    font-size:28/75rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  }
  }
  .btn_wc{
    margin-top:20px;
     font-weight:bold;
  }
  /*.btn{
    width:629/75rem;
    height:100/75rem;
    line-height:100/75rem;
    margin:auto;
    background:#E6464A;
    color:#fff;
    font-size:32/75rem;
    border-radius: 6px;
    text-align:center;
    box-shadow:4px 0px 16px rgba(153,153,153,0.63);
    margin-top:60/75rem;
  }
*/
/*遮罩层*/
  .mask{
    position:fixed;
    top:0;
    left:0;
    bottom:0;
    right:0;
   /* background:#afb0b2;*/
    background:rgba(27,27,27,0.9);
    opacity:0.9;
    z-index:11;
  }

</style>




// WEBPACK FOOTER //
// src/pages/register.vue